import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="poll"
export default class extends Controller {
  static values = { interval: { type: Number, default: 10000 } }; // Default 10 seconds

  connect() {
    this.timer = setInterval(() => {
      this.element.closest("turbo-frame")?.reload();
    }, this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }
}
